import React from 'react';
import './Spinner.css';

/**
 * Selkirk Copper Mines Loading Spinner
 * Custom animated loader featuring the Selkirk logo arrow spinning around a yellow ball on top
 * 
 * @param {Object} props
 * @param {string} props.size - Size of the spinner: 'small' (40px), 'medium' (80px), 'large' (120px)
 * @param {string} props.className - Additional CSS classes
 */
const Spinner = ({ size = 'medium', className = '' }) => {
  const sizeMap = {
    small: '40px',
    medium: '80px',
    large: '120px'
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  return (
    <svg 
      className={`selkirk-loader ${className}`}
      viewBox="-60 -60 220 220"
      style={{ width: spinnerSize, height: spinnerSize }}
      aria-label="Loading"
      role="img"
    >
      {/* Arrow shape - renders first (behind) */}
      <path
        className="loader-arrow"
        d="M50 5 L15 80 L35 80
           A 15 15 0 0 1 65 80
           L85 80 Z"
        fill="#000000" 
      />

      {/* Yellow ball - renders last (on top) */}
      <circle
        className="loader-circle"
        cx="50"
        cy="20"
        r="12"
        fill="#f4b400" 
      />
    </svg>
  );
};

export default Spinner;

